(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../../SubMenuLink', 'prop-types', '../../MenuAnimation'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../../SubMenuLink'), require('prop-types'), require('../../MenuAnimation'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.SubMenuLink, global.propTypes, global.MenuAnimation);
    global.SubMenuDrawer = mod.exports;
  }
})(this, function (exports, _react, _SubMenuLink, _propTypes, _MenuAnimation) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _SubMenuLink2 = _interopRequireDefault(_SubMenuLink);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _MenuAnimation2 = _interopRequireDefault(_MenuAnimation);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SubMenuDrawer = function (_React$Component) {
    _inherits(SubMenuDrawer, _React$Component);

    function SubMenuDrawer(props) {
      _classCallCheck(this, SubMenuDrawer);

      var _this = _possibleConstructorReturn(this, (SubMenuDrawer.__proto__ || Object.getPrototypeOf(SubMenuDrawer)).call(this, props));

      _this.state = {
        subHeight: 0
      };
      return _this;
    }

    _createClass(SubMenuDrawer, [{
      key: 'buildSubList',
      value: function buildSubList(list) {
        var _this2 = this;

        if (list) {
          return list.map(function (listItem, i) {
            return _react2.default.createElement(
              _SubMenuLink2.default,
              {
                href: listItem.src,
                isHovered: _this2.props.isHovered,
                list: list,
                key: i,
                style: {
                  color: 'inherit',
                  textDecoration: 'underline',
                  fontSize: '14px',
                  transition: 'background 0.2s ease-in-out',
                  padding: _this2.props.isMobile ? '5px 10px' : '10px 10px 10px 15px',
                  display: 'block',
                  margin: '0',
                  overflow: 'hidden',
                  position: 'relative'
                },
                hoverStyles: {
                  color: '#fff',
                  background: '#555',
                  listStyle: 'none',
                  fontWeight: '400'
                }
              },
              _react2.default.createElement(
                'li',
                null,
                listItem.text
              )
            );
          });
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.getHeight();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.getHeight();
      }
    }, {
      key: 'getHeight',
      value: function getHeight() {
        if (this.div !== undefined) {
          if (this.state.subHeight !== this.div.clientHeight) {
            this.setState({ subHeight: this.div.clientHeight });
          };
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var desktopStyles = {
          position: 'absolute',
          background: '#333333',
          display: 'block',
          // height: this.props.height,
          height: this.props.height > this.state.subHeight ? this.props.height : this.props.subMenuHeight,
          top: '0',
          fontSize: '14px',
          overflow: 'visible'
        };
        var mobileStyles = {
          position: 'relative',
          background: '#222',
          width: 'auto',
          top: '0',
          fontSize: '14px'
        };

        if (!this.props.list) {
          return false;
        } else {
          return _react2.default.createElement(
            _MenuAnimation2.default,
            {
              animationState: this.props.isMobile ? this.props.isOpen : this.props.isHovered,
              duration: 250,
              styles: this.props.isMobile ? mobileStyles : desktopStyles,
              isMobile: this.props.isMobile,
              subMenuHeight: this.props.subMenuHeight
            },
            _react2.default.createElement(
              'ul',
              {
                className: 'sub-menu-list',
                style: {
                  listStyle: 'none',
                  margin: '0',
                  padding: '0',
                  display: 'block'
                },
                ref: function ref(div) {
                  _this3.div = div;
                }
              },
              this.buildSubList(this.props.list)
            )
          );
        }
      }
    }]);

    return SubMenuDrawer;
  }(_react2.default.Component);

  exports.default = SubMenuDrawer;


  SubMenuDrawer.propTypes = {
    subMenuHeight: _propTypes2.default.object,
    listOpen: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool,
    isHovered: _propTypes2.default.bool,
    list: _propTypes2.default.array,
    isOpen: _propTypes2.default.bool,
    height: _propTypes2.default.number
  };
});